import { render, staticRenderFns } from "./tab-details.vue?vue&type=template&id=4e690de4&scoped=true"
import script from "./tab-details.vue?vue&type=script&lang=js"
export * from "./tab-details.vue?vue&type=script&lang=js"
import style0 from "./tab-details.vue?vue&type=style&index=0&id=4e690de4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e690de4",
  null
  
)

export default component.exports